// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__vSBSw","blue":"Loader_blue__m5O3W"};